import { Box } from "@mui/system";
import React, { useContext, useEffect, useState } from "react";
import RedirectSection from "../../components/redirect-section";
import UserContext from "../../services/user/user";
import APIContext from "../../services/api/api";

import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import WidgetsOrderController from "../../components/_elements/widgets-order-controller";
import { CircularProgress } from "@mui/material";
import Button from "../../components/base/button";
import { CardsProvider } from "../../services/cards/cards";
import ErrorSection from "../../components/error-section";

import { FormattedMessage } from "react-intl";
import Typography from "@mui/material/Typography";
import { ClearCustoms } from "../ClearCustoms/OveralKPI";
import { WidgetsCards } from "../../components/cards/WidgetsCards";
import { EcUserDataContext } from "@eclear-ag/ec-common-ui";
import { canAccessClearCustoms } from "../ClearCustoms/tools/tool";

function App() {
  const [isTokenValid, setIsTokenValid] = useState(false);
  const { isSpotEmpty } = useContext(APIContext);
  const { userData: ecUserData } = useContext(EcUserDataContext);

  // Check if user has CLEARCUSTOMS subscription
  const isSubscribedToClearCustoms = canAccessClearCustoms({
    userData: ecUserData
  });

  const {
    isReorder,
    setIsReorder,
    setWidgetsList,
    userWidgetPlaceholder,
    userData
  } = useContext(UserContext);

  const saveReorder = () => {
    setIsReorder(false);
    // save reorder to API
  };

  const cancelReorder = () => {
    setIsReorder(false);
    // cancel reorder
    setWidgetsList(userWidgetPlaceholder);
  };

  useEffect(() => {
    // Check token Exp
    const dateNow = new Date();
    const dateToken = new Date(userData.tokenExp);

    if (dateNow < dateToken) {
      console.log("token expired");
      setIsTokenValid(true);
    } else {
      setIsTokenValid(true);
    }
  });

  const gridConfig = {
    topCards: {
      xs: 12,
      sm: 6,
      md: 3,
      lg: 3
    },
    revenue: {},
    tables: {
      xs: 12,
      sm: 12,
      md: 6,
      lg: 6
    },
    taxRateCards: {
      xs: 12,
      sm: 12,
      md: 12,
      lg: 6
    },
    vatAmountCards: {
      xs: 12,
      sm: 6,
      md: 6,
      lg: 6
    }
  };

  return (
    <React.Fragment>
      {isTokenValid ? (
        isReorder ? (
          <Box>
            <DndProvider backend={HTML5Backend}>
              <WidgetsOrderController />
            </DndProvider>

            <Button
              aria-label="save layout"
              variant="contained"
              sx={{ mr: 3 }}
              onClick={saveReorder}
            >
              Save
            </Button>
            <Button
              aria-label="cancel"
              variant="outlined"
              onClick={cancelReorder}
            >
              Cancel
            </Button>
          </Box>
        ) : (
          <>
            {isSpotEmpty === true ||
            localStorage.getItem("isSpotEmpty") === "true" ? (
              <ErrorSection
                errorList={[
                  {
                    header: "No Data available yet!",
                    list: [
                      'Please add your Financial-Connectors  to your profile. <span to="/">Here</span>'
                    ]
                  }
                ]}
              >
                <Typography variant="h3" className="error-header">
                  <FormattedMessage id="spotNoData" />
                </Typography>
                <ul>
                  <li>
                    <FormattedMessage
                      id="financialConnectors.error"
                      values={{
                        b: (...chunks) => {
                          return <b style={{ fontWeight: "500" }}>{chunks}</b>;
                        },
                        br: <br />
                      }}
                    />
                  </li>
                </ul>
              </ErrorSection>
            ) : null}
            <Box
              className={
                isSubscribedToClearCustoms
                  ? "has-clearcustoms"
                  : "no-clearcustoms"
              }
            >
              <CardsProvider>
                <ClearCustoms />
                <WidgetsCards gridConfig={gridConfig} />
              </CardsProvider>
            </Box>
          </>
        )
      ) : (
        <Box sx={{ textAlign: "center" }}>
          <CircularProgress />
        </Box>
      )}

      <RedirectSection />
    </React.Fragment>
  );
}

export default App;
